import React from 'react';

export const Debug = () => {
  return <div>Demo </div>;
};
